// API service functions

export interface PriceData {
  price: number;
  volume: number;
  high24h: number;
  low24h: number;
  change24h: number;
  source: string;
  timestamp: number;
}

export async function fetchPrice(): Promise<PriceData> {
  try {
    const scanApiUrl = import.meta.env.VITE_SCAN_API_URL || 'https://scan.larissa.network/api/v2';
    const response = await fetch(`${scanApiUrl}/stats`, { cache: 'no-store' });

    if (!response.ok) {
      throw new Error(`Scan stats API returned ${response.status}`);
    }

    const data = await response.json();
    const price = parseFloat(data.coin_price || '0');
    const change24h = parseFloat(data.coin_price_change_percentage || '0');

    return {
      price,
      volume: 0,
      high24h: 0,
      low24h: 0,
      change24h,
      source: 'scan-stats',
      timestamp: Date.now(),
    };
  } catch (error) {
    console.error('Error fetching price from scan stats:', error);
    throw error;
  }
}

// Cross-chain bridge chart types
export interface ChainDestination {
  chain: number;
  volume: string;
  percentage: number;
}

export interface ChainTransaction {
  chain: number;
  volume: string;
  percentage: number;
  destinations: ChainDestination[];
}

export interface CrossChainChartResponse {
  status: boolean;
  message: string;
  data: {
    txs: ChainTransaction[];
  };
}

export async function fetchCrossChainChart(
  metricType: 'volume' | 'transfers' = 'volume',
  timePeriod: '24h' | '7d' | '30d' | 'all' = '24h'
): Promise<CrossChainChartResponse> {
  try {
    const apiUrl = import.meta.env.VITE_BRIDGE_API_URL || '';
    const response = await fetch(
      `${apiUrl}/getCrossChainChart?metricType=${metricType}&timePeriod=${timePeriod}`,
      {
        cache: 'no-store',
      }
    );

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching cross-chain chart data:', error);
    throw error;
  }
}


